// extracted by mini-css-extract-plugin
module.exports = {"wrap":"lg","contentWrapCtaDefault":"mg","disabled":"ng","contentWrapCtaWhite":"og","promos":"pg","lazyPromo":"qg","mainContent":"rg","headingText":"sg","copy":"tg","subtext":"ug"};